import {http} from './config/config-receituario'

export default{
    listar:async(token,itens_pagina,pagina,filter)=>{
        if(itens_pagina && pagina){
            return  http.get('produtos',{
                headers:{
                    'Authorization':token
                },
                params: {
                    itens_pagina,
                    pagina,
                    filter,
                },
            }) 
        }else{
            return  http.get('produtos',{
                headers:{
                    'Authorization':token
                }
            })
        }
    },
    listarNotFilter:async(token,itens_pagina,pagina)=>{
        if(itens_pagina && pagina){
            return  http.get('produtos/filter',{
                headers:{
                    'Authorization':token
                },
                params: {
                    take: itens_pagina,
                    page: pagina,
                },
            }) 
        }else{
            return  http.get('produtos',{
                headers:{
                    'Authorization':token
                }
            })
        }
    },
    salvar:(token, produto)=>{
        return http.post('produtos',produto,{
            headers:{
                'Authorization':token
            }
        })
    },
    deletar:(token, idProduto)=>{
        return http.delete('produtos/'+idProduto,{
            headers:{
                'Authorization':token
            }
        })
    },
    update:(token, produto)=>{
        return http.put('produtos/'+produto.id_produto,produto,{
            headers:{
                'Authorization':token
            }
        })
    }

}
